import React from "react";
import { v4 } from "uuid";
import PropTypes from "prop-types";
import styles from "./EventSnapshotList.module.css";

import EventSnapshotItem from "../EventSnapshotItem";

export function EventSnapshotList({ snapshots, onClick, onNoteClick }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>File Name</p>
        <p>Created On</p>
        <p>Event Name</p>
        <p>Total Users</p>
        <p>Notes</p>
      </div>
      <ul className={styles.list}>
        {snapshots.map((snapshot) => (
          <EventSnapshotItem
            eventSnapshotInfo={snapshot}
            key={v4()}
            onClick={() => onClick(snapshot)}
            onNoteClick={snapshot.notes ? () => onNoteClick(snapshot) : null}
          />
        ))}
      </ul>
    </div>
  );
}

EventSnapshotList.propTypes = {
  /**
   * Array of snapshot objects.
   */
  snapshots: PropTypes.arrayOf(
    PropTypes.shape({
      fileName: PropTypes.string,
      createdOn: PropTypes.string,
      eventName: PropTypes.string,
      totalUsers: PropTypes.string,
      notes: PropTypes.string,
    })
  ),
  /**
   * Function that fires when the details button is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Function that fires when the notes button is clicked.
   */
  onNoteClick: PropTypes.func,
};
